import styled from "styled-components";
import { TypoDisplay } from "@/styles/Styled.Typography";
import { fluid } from "@/styles/utils/fluid";

console.log("TypoDisplay:", TypoDisplay); // should log a function

export const HeroWrapper = styled.section`
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  overflow: hidden;
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  transition: opacity 0.3s ease;
  margin: ${({ theme }) => `
      58px
      0
      ${fluid({
        minSize: theme.spacing.hero.xs,
        maxSize: theme.spacing.hero.lg,
        minVW: theme.breakpointValues.xs,
        maxVW: theme.breakpointValues.lg,
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.lg,
      })}
    `};
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    margin: ${({ theme }) => `
      0
      0
      ${fluid({
        minSize: theme.spacing.hero.lg,
        maxSize: theme.spacing.hero.xl,
        minVW: theme.breakpointValues.lg,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.lg,
        baseFontMax: theme.baseFont.xl,
      })}
    `};
  }
`;

export const HeroGridWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
`;

export const HeroRevealWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  pointer-events: none;
  display: flex;
  flex-direction: column;
`;

export const HeroRippedPaperWrapper = styled.div`
  width: 100%;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const HeroRevealPanel = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const CatchDisplayWrapper = styled.div`
  width: 100%;
  text-align: center;
  position: relative;
  margin: 0;
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.fontScale.majorSecond.display,
      maxSize: theme.fontScale.augmentedFourth.display,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    ${fluid({
      minSize: theme.fontScale.majorSecond.display,
      maxSize: theme.fontScale.augmentedFourth.display,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    calc(${fluid({
      minSize: theme.fontScale.majorSecond.display,
      maxSize: theme.fontScale.augmentedFourth.display,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })} / 2)
  `};
`;

export const CatchDisplay = styled(TypoDisplay)`
  color: ${({ theme }) => theme.colors.white};
  word-break: break-word;
  margin: 0;
  opacity: 1;
  transition: font-size 0.3s ease-in-out;
`;
